module.exports = __webpack_public_path__ + "public/Icons/availableIcon.png?994377cf";